import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '@/views/About'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/yezza-playground',
    name: 'Playground',
    component: () => import('../views/Playground.vue'),
  },
  {
    path: '/yezza-landingpage',
    name: 'LandingPages',
    component: () => import('../views/LandingPage.vue'),
  },
  {
    path: '/',
    name: 'Home',
    component: About,
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import('../views/signup/SignUp.vue'),
    props: true,
  },
  {
    path: '/signup/donation',
    name: 'SignUpDonation',
    component: () => import('../views/signup/SignUpDonation.vue'),
    props: true,
  },
  {
    path: '/signup/connect',
    name: 'SignUpConnect',
    component: () => import('../views/signup/SignUpConnect.vue'),
    props: true,
  },
  {
    path: '/signup/clinic',
    name: 'SignUpClinic',
    component: () => import('../views/signup/SignUpClinic.vue'),
    props: true
  },
  {
    path: '/signup/review',
    name: 'SignUpReview',
    component: () => import('../views/signup/SignUpReview.vue'),
    props: true
  },
  {
    path: '/signup/clinic/subscribe',
    name: 'SubscribeClinic',
    component: () => import('../views/signup/SubscribeClinic.vue'),
    props: true
  },
  {
    path: '/admin/verify-yearly-subscription-payment',
    name: 'VerifyYearlySubscriptionPayment',
    props: true,
    component: () => import('../views/admin/VerifyYearlySubscriptionPayment.vue'),
  },
  {
    path: '/start/user',
    name: 'InviteSignUp',
    component: () => import('../views/InviteSignUp.vue'),
    props: true,
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import('../views/SignIn.vue'),
    props: true,
  },
  {
    path: '/impersonate',
    name: 'Yadmin',
    component: () => import('../views/Yadmin.vue'),
    props: true,
  },
  {
    path: '/approve-signin/:token',
    name: 'ApproveSignIn',
    component: () => import('../views/ApproveSignIn.vue'),
    props: true,
  },
  {
    path: '/mobile-app',
    name: 'MobileApp',
    component: () => import('../views/MobileApp.vue'),
    props: true,
  },
  {
    path: '/signin/forgot',
    name: 'Forgot',
    component: () => import('../views/Forgot.vue'),
    props: true,
  },
  {
    path: '/signin/verify',
    name: 'Verify',
    component: () => import('../views/Verify.vue'),
    props: true,
  },
  {
    path: '/signin/reset',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue'),
    props: true,
  },
  {
    path: '/signout',
    name: 'SignOut',
    component: () => import('../views/SignOut.vue'),
  },
  {
    path: '/companies',
    name: 'Companies',
    component: () => import('../views/Companies.vue'),
  },
  {
    path: '/start/company',
    name: 'NewCompany',
    component: () => import('../views/NewCompany.vue'),
  },
  {
    path: '/start/donation',
    name: 'NewDonationOrganization',
    component: () => import('../views/NewDonationOrganization.vue'),
  },
  {
    path: '/start/connect',
    name: 'NewConnectCompany',
    component: () => import('../views/NewConnectCompany.vue'),
  },
  {
    path: '/start/clinic',
    name: 'NewClinicCompany',
    component: () => import('../views/NewClinicCompany.vue')
  },
  {
    path: '/start/review',
    name: 'NewReviewCompany',
    component: () => import('../views/NewReviewCompany.vue')
  },
  {
    path: '/invite/:token',
    name: 'AcceptInvite',
    component: () => import('../views/AcceptInvite.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/print-qr',
    name: 'PrintQrCode',
    component: () => import('../views/PrintQrCode.vue'),
  },
  {
    path: '/pdf-qr',
    name: 'PdfQrCode',
    component: () => import('../views/PdfQrCode.vue'),
  },
  {
    path: '/unsubscribe-email',
    name: 'UnsubscribeEmail',
    component: () => import('../views/UnsubscribeEmail.vue'),
  },
  {
    path: '/connect/complete',
    name: 'InviteConnectComplete',
    component: () => import('../views/InviteConnectComplete.vue'),
    props: true,
  },
  {
    path: '/affiliate',
    name: 'AffiliateHome',
    component: () => import('../views/affiliate/Home.vue'),
    children: [
      {
        path: '/affiliate/dashboard',
        name: 'AffiliateDashboard',
        props: true,
        component: () => import('../views/affiliate/Dashboard.vue'),
      },
      {
        path: '/affiliate/profile',
        name: 'AffiliateProfile',
        props: true,
        component: () => import('../views/affiliate/Profile.vue'),
      },
      {
        path: '/affiliate/notifications',
        name: 'AffiliateNotification',
        props: true,
        component: () => import('../views/affiliate/Notifications.vue'),
      },
    ],
  },
  {
    path: '/admin',
    name: 'AdminHome',
    component: () => import('../views/admin/Home.vue'),
    children: [
      {
        path: '/admin/verify-billing',
        name: 'VerifyBilling',
        component: () => import('../views/admin/VerifyPayment.vue'),
      },
      {
        path: '/admin/prepaid-topup-verify-payment',
        name: 'VerifyPrepaidTopup',
        component: () => import('../views/admin/VerifyPrepaidTopup.vue'),
      },
      {
        path: '/admin/dashboard',
        name: 'Dashboard',
        props: true,
        component: () => import('../views/admin/Dashboard.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', '')
          next()
        },
      },
      {
        path: '/admin/analytics',
        name: 'Analytics',
        props: true,
        component: () => import('../views/admin/Analytics.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'analytics')
          next()
        },
      },
      {
        path: '/admin/database',
        name: 'Database',
        props: true,
        component: () => import('../views/admin/Database.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'customers')
          next()
        },
      },
      {
        path: '/admin/crm/lead',
        name: 'Database',
        props: true,
        component: () => import('../views/admin/crm/Leads.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'customers')
          next()
        },
      },
      {
        path: '/admin/crm/approval',
        name: 'Database',
        props: true,
        component: () => import('../views/admin/crm/PaymentApproval.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'customers')
          next()
        },
      },
      {
      path: '/admin/crm/onboarding',
      name: 'Database',
      props: true,
      component: () => import('../views/admin/crm/Onboarding.vue'),
      beforeEnter: (to, from, next) => {
        store.commit('ui/setNavbarTitle', 'customers')
        next()
      },
      },
      {
        path: '/admin/crm/renewal',
        name: 'Database',
        props: true,
        component: () => import('../views/admin/crm/Renewal.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'customers')
          next()
        },
      },
      {
        path: '/admin/free-database',
        name: 'FreeDatabase',
        props: true,
        component: () => import('../views/admin/Database.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'customers')
          next()
        },
      },
      {
        path: '/admin/follow-up',
        name: 'FollowUp',
        props: true,
        component: () => import('../views/admin/FollowUp.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'follow_up')
          next()
        },
      },
      {
        path: '/admin/orders',
        name: 'Orders',
        props: true,
        component: () => import('../views/admin/Orders.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'orders')
          next()
        },
      },
      {
        path: '/admin/orders-new',
        name: 'OrdersNew',
        props: true,
        component: () => import('../views/admin/OrdersNew.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'orders')
          next()
        },
      },
      {
        path: '/admin/orders/packing-slips',
        name: 'YezzaPackingSlips',
        props: true,
        component: () => import('../views/admin/order/YezzaPackingSlips.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'packing_slips')
          next()
        },
      },
      {
        path: '/admin/orders/pick-list',
        name: 'YezzaPickList',
        props: true,
        component: () => import('../views/admin/order/YezzaPickList.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'pick_list')
          next()
        },
      },
      {
        path: '/admin/transactions',
        name: 'Transactions',
        props: true,
        component: () => import('../views/admin/Transactions.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'transactions')
          next()
        },
      },
      {
        path: '/admin/payouts',
        name: 'Payouts',
        props: true,
        component: () => import('../views/admin/Payouts.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'payouts')
          next()
        },
      },
      {
        path: '/admin/commissions',
        name: 'Commissions',
        props: true,
        component: () => import('../views/admin/Commissions.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'commissions')
          next()
        },
      },
      {
        path: '/admin/forms',
        name: 'AdminForms',
        props: true,
        component: () => import('../views/admin/Forms.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'whatsapp_forms')
          next()
        },
      },
      {
        path: '/admin/landing-pages',
        name: 'AdminLandingPages',
        props: true,
        component: () => import('../views/admin/LandingPages.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'sales_pages')
          next()
        },
      },
      {
        path: '/admin/local-ads',
        name: 'AdminLandingPages',
        props: true,
        component: () => import('../views/admin/LocalAdsPage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Local ads')
          next()
        },
      },
      {
        path: '/admin/donationforms',
        name: 'DonationForms',
        props: true,
        component: () => import('../views/admin/DonationForms.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'donation_forms')
          next()
        },
      },
      {
        path: '/admin/sales-team',
        name: 'Sales Team',
        props: true,
        component: () => import('../views/admin/SalesTeam.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'sales_team')
          next()
        },
      },
      {
        path: '/admin/products',
        name: 'Products',
        props: true,
        component: () => import('../views/admin/Products.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'products')
          next()
        },
      },
      {
        path: '/admin/products-inventory',
        name: 'ProductsInventory',
        props: true,
        component: () => import('../views/admin/ProductsInventory.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'manage_inventory')
          next()
        },
      },
      // {
      //   path: '/admin/products-price',
      //   name: 'ProductsPrice',
      //   props: true,
      //   component: () => import('../views/admin/ProductsPrice.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'Manage Price')
      //     next()
      //   }
      // },
      {
        path: '/admin/products-inventory/:pid',
        name: 'ProductsInventoryDetails',
        props: true,
        component: () => import('../views/admin/ProductsInventoryDetails.vue'),
      },
      {
        path: '/admin/appointments',
        name: 'Appointments',
        props: true,
        component: () => import('../views/admin/Appointments.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'appointments')
          next()
        },
      },
      {
        path: '/admin/offers',
        name: 'Offers',
        props: true,
        component: () => import('../views/admin/Offers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'offers')
          next()
        },
      },
      {
        path: '/admin/resellers',
        name: 'Resellers',
        props: true,
        component: () => import('../views/admin/Resellers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'commission')
          next()
        },
      },
      {
        path: '/admin/resellers/payouts',
        name: 'ResellersPayouts',
        props: true,
        component: () => import('../views/admin/ResellersPayouts.vue'),
      },
      {
        path: '/admin/yezza-store',
        name: 'YezzaStore',
        props: true,
        component: () => import('../views/admin/YezzaStore.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Yezza Store')
          next()
        },
      },
      {
        path: '/admin/yezza-store/pages',
        name: 'YezzaStorePages',
        props: true,
        component: () => import('../views/yezzastore/YezzaStorePages.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'pages')
          next()
        },
      },
      {
        path: '/admin/yezza-store/pages/add',
        name: 'AddYezzaStorePage',
        props: true,
        component: () => import('../views/yezzastore/AddYezzaStorePage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'database')
          next()
        },
      },
      {
        path: '/admin/yezza-mall',
        name: 'YezzaMall',
        props: true,
        component: () => import('../views/admin/YezzaMall.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Angsana Mall')
          next()
        },
      },
      {
        path: '/admin/yezza-book/incomes',
        name: 'YezzaBookIncome',
        props: true,
        component: () => import('../views/admin/yezzabook/YezzaBookIncome.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'income')
          next()
        },
      },
      {
        path: '/admin/yezza-book/expenses',
        name: 'YezzaBookExpense',
        props: true,
        component: () => import('../views/admin/yezzabook/YezzaBookExpense.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'expense')
          next()
        },
      },
      {
        path: '/admin/yezza-book/reports',
        name: 'YezzaBookReports',
        props: true,
        component: () => import('../views/admin/yezzabook/YezzaBookReports.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'reports')
          next()
        },
      },
      {
        path: '/admin/connect/customers',
        name: 'ConnectCustomers',
        component: () => import('../views/admin/connect/customers/Customers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'customers')
          next()
        },
      },
      {
        path: '/admin/connect/customers/upload-csv',
        name: 'ConnectCustomersImport',
        component: () => import('../views/admin/connect/customers/CustomerUploadCsv.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'customers')
          next()
        },
      },
      {
        path: '/admin/connect/customers/send-message',
        name: 'CustomersSendMessage',
        component: () => import('../views/admin/connect/customers/send/SendMessage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_message')
          next()
        },
      },
      {
        path: '/admin/connect/customers/send-email',
        name: 'CustomersSendEmail',
        component: () => import('../views/admin/connect/customers/send/SendEmail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_message')
          next()
        },
      },
      {
        path: '/admin/connect/status',
        name: 'ConnectStatus',
        component: () => import('../views/admin/connect/customers/status/Status.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'status')
          next()
        },
      },
      {
        path: '/admin/connect/segments',
        name: 'ConnectSegments',
        component: () => import('../views/admin/module/segment/Segments.vue'),
        props: { os: 'connect' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/connect/segments/create',
        name: 'ConnectSegmentsCreate',
        component: () => import('../views/admin/module/segment/CreateSegment.vue'),
        props: { os: 'connect' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/connect/segments/upload-csv',
        name: 'ConnectSegmentsUpload',
        component: () => import('../views/admin/module/segment/SegmentUploadCsv.vue'),
        props: { os: 'connect' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/connect/segments/:id',
        name: 'ConnectSegmentDetail',
        props: true,
        component: () => import('../views/admin/connect/segments/SegmentDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segment_detail')
          next()
        },
      },
      {
        path: '/admin/connect/segments/:id/add-customers',
        name: 'ConnectSegmentDetailCustomers',
        props: true,
        component: () => import('../views/admin/connect/segments/SegmentAddCustomers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segment_detail')
          next()
        },
      },
      {
        path: '/admin/connect/segments/:id/send-message',
        name: 'ConnectSegmentSendMessage',
        props: true,
        component: () => import('../views/admin/connect/segments/send/SegmentSendMessage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_message')
          next()
        },
      },
      {
        path: '/admin/connect/segments/:id/send-email',
        name: 'ConnectSegmentSendEmail',
        props: true,
        component: () => import('../views/admin/connect/segments/send/SegmentSendEmail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_email')
          next()
        },
      },
      {
        path: '/admin/connect/tasks',
        name: 'ConnectTasks',
        component: () => import('../views/admin/connect/tasks/Tasks.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'tasks')
          next()
        },
      },
      {
        path: '/admin/connect/tasks/:id',
        name: 'ConnectTaskDetail',
        props: true,
        component: () => import('../views/admin/connect/tasks/TaskDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'task_detail')
          next()
        },
      },
      {
        path: '/admin/connect/users',
        name: 'ConnectUsers',
        component: () => import('../views/admin/connect/Users.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'users')
          next()
        },
      },
      {
        path: '/admin/connect/webhook',
        name: 'ConnectWebhook',
        component: () => import('../views/admin/connect/WebhookIntegration.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'webhook_integration')
          next()
        },
      },
      {
        path: '/admin/restaurant/pos-setup',
        name: 'PosSetup',
        props: true,
        component: () => import('../views/admin/restaurant/PosSetup.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'pos_setup')
          next()
        },
      },
      {
        path: '/admin/restaurant/user-access',
        name: 'UserAccess',
        props: true,
        component: () => import('../views/admin/restaurant/UserAccess.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'pos_user_access')
          next()
        },
      },
      {
        path: '/admin/restaurant/assign-table',
        name: 'AssignTable',
        props: true,
        component: () => import('../views/admin/restaurant/AssignTable.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'assign_table')
          next()
        },
      },
      {
        path: '/admin/restaurant/payment-settings',
        name: 'PaymentSettings',
        props: true,
        component: () => import('../views/admin/restaurant/PaymentSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'payment_settings')
          next()
        },
      },
      {
        path: '/admin/restaurant/transactions',
        name: 'TransactionHistory',
        props: true,
        component: () => import('../views/admin/restaurant/Transactions.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'transaction_history')
          next()
        },
      },
      {
        path: '/admin/restaurant/receipt-template',
        name: 'ReceiptTemplate',
        props: true,
        component: () => import('../views/admin/restaurant/ReceiptTemplate.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'receipt_template')
          next()
        },
      },
      {
        path: '/admin/restaurant/hardware-settings',
        name: 'HardwareSettings',
        props: true,
        component: () => import('../views/admin/restaurant/HardwareSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'hardware_settings')
          next()
        },
      },
      {
        path: '/admin/restaurant/menu-categories',
        name: 'MenuCategories',
        props: true,
        component: () => import('../views/admin/restaurant/MenuCategories.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'menu_categories')
          next()
        },
      },
      {
        path: '/admin/restaurant/table-ordering',
        name: 'TableOrdering',
        props: true,
        component: () => import('../views/admin/restaurant/TableOrdering.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'table_ordering')
          next()
        },
      },
      {
        path: '/admin/donation/analytics',
        name: 'DonationAnalytics',
        props: true,
        component: () => import('../views/admin/donation/Analytics.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'analytics')
          next()
        },
      },
      {
        path: '/admin/donation/campaign',
        name: 'Campaign',
        props: true,
        component: () => import('../views/admin/donation/Campaign.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'campaign')
          next()
        },
      },
      {
        path: '/admin/donation/campaign/:pid',
        name: 'ManageCampaign',
        props: true,
        component: () => import('../views/admin/donation/ManageCampaign.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'manage_campaign')
          next()
        },
      },
      {
        path: '/admin/donation/donors',
        name: 'Donors',
        props: true,
        component: () => import('../views/admin/donation/Donors.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'donors')
          next()
        },
      },
      {
        path: '/admin/donation/donors/import',
        name: 'DonorsImport',
        component: () => import('../views/admin/donation/DonorsImportCustomers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'donors')
          next()
        },
      },
      {
        path: '/admin/donation/donors/send-message',
        name: 'DonorsSendMessage',
        component: () => import('../views/admin/donation/DonorsSendMessage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_message')
          next()
        },
      },
      {
        path: '/admin/donation/donors/send-email',
        name: 'DonorsSendEmail',
        component: () => import('../views/admin/donation/DonorsSendEmail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_email')
          next()
        },
      },
      {
        path: '/admin/donation/fundraisers',
        name: 'Fundraisers',
        props: true,
        component: () => import('../views/admin/donation/Fundraisers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'fundraisers')
          next()
        },
      },
      {
        path: '/admin/donation/segments',
        name: 'DonationSegments',
        component: () => import('../views/admin/module/segment/Segments.vue'),
        props: { os: 'donation' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/donation/segments/create',
        name: 'DonationSegmentsCreate',
        component: () => import('../views/admin/module/segment/CreateSegment.vue'),
        props: { os: 'donation' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/donation/segments/upload-csv',
        name: 'DonationSegmentsUpload',
        component: () => import('../views/admin/module/segment/SegmentUploadCsv.vue'),
        props: { os: 'donation' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/donation/segments/:id',
        name: 'DonationSegmentDetail',
        props: true,
        component: () => import('../views/admin/donation/SegmentDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segment_detail')
          next()
        },
      },
      {
        path: '/admin/donation/segments/:id/send-message',
        name: 'DonationSegmentSendMessage',
        props: true,
        component: () => import('../views/admin/donation/SegmentSendMessage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_message')
          next()
        },
      },
      {
        path: '/admin/donation/segments/:id/send-email',
        name: 'DonationSegmentSendEmail',
        props: true,
        component: () => import('../views/admin/donation/SegmentSendEmail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_email')
          next()
        },
      },
      {
        path: '/admin/donation/segments/:id/add-customers',
        name: 'DonationSegmentDetailCustomers',
        props: true,
        component: () => import('../views/admin/donation/SegmentAddCustomers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/donation/settings',
        name: 'DonationSettings',
        props: true,
        component: () => import('../views/admin/donation/Settings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/donation/settings/payment',
        name: 'DonationPaymentSettings',
        props: true,
        component: () => import('../views/admin/donation/settings/PaymentSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/donation/settings/general',
        name: 'DonationGeneralSettings',
        props: true,
        component: () => import('../views/admin/donation/settings/GeneralSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },

      {
        path: '/admin/donation/settings/subscription',
        name: 'DonationSubscriptionSettings',
        props: true,
        component: () => import('../views/admin/donation/settings/SubscriptionSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },

      {
        path: '/admin/donation/settings/bills',
        name: 'DonationBillsSettings',
        props: true,
        component: () => import('../views/admin/donation/settings/BillsSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },

      {
        path: '/admin/donation/settings/account',
        name: 'DonationAccountSettings',
        props: true,
        component: () => import('../views/admin/donation/settings/AccountSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/donation/settings/marketing-tracking',
        name: 'DonationMarketingtSettings',
        props: true,
        component: () => import('../views/admin/donation/settings/MarketingTrackingSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/donation/settings/integration',
        name: 'DonationIntegrationSettings',
        props: true,
        component: () => import('../views/admin/donation/settings/IntegrationSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/analytics',
        name: 'ClinicAnalytics',
        props: true,
        component: () => import('../views/admin/clinic/Analytics.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'analytics')
          next()
        },
      },
      {
        path: '/admin/clinic/appointment',
        name: 'ClinicAppointment',
        props: true,
        component: () => import('../views/admin/clinic/Appointment.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'appointment')
          next()
        },
      },
      {
        path: '/admin/clinic/message-template',
        name: 'ClinicMessageTemplate',
        props: true,
        component: () => import('../views/admin/clinic/MessageTemplate.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'edit_message_template')
          next()
        },
      },
      {
        path: '/admin/clinic/patient',
        name: 'ClinicPatient',
        props: true,
        component: () => import('../views/admin/clinic/Patients.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'patient')
          next()
        },
      },
      {
        path: '/admin/clinic/review',
        name: 'ClinicReview',
        props: { os: 'clinic' },
        component: () => import('../components/review/listing/ReviewListingPage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'review')
          next()
        },
      },
      {
        path: '/admin/clinic/review-settings',
        name: 'ClinicReviewSettings',
        props: { os: 'clinic' },
        component: () => import('../components/review/settings/ReviewSettingPage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Review Settings')
          next()
        },
      },
      {
        path: '/admin/clinic/review-api-key',
        name: 'ClinicReviewApiKey',
        props: true,
        component: () => import('../views/admin/review/settings/ApiKey.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'API Key')
          next()
        },
      },
      {
        path: '/admin/clinic/segments',
        name: 'ClinicSegment',
        props: true,
        component: () => import('../views/admin/clinic/Segments.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segment')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/create',
        name: 'ClinicSegmentsCreate',
        component: () => import('../views/admin/module/segment/CreateSegment.vue'),
        props: { os: 'clinic' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/upload-csv',
        name: 'ClinicSegmentsUpload',
        component: () => import('../views/admin/module/segment/SegmentUploadCsv.vue'),
        props: { os: 'clinic' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/:id',
        name: 'ClinicSegmentDetail',
        props: true,
        component: () => import('../views/admin/clinic/SegmentDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segment_detail')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/:id/send-message',
        name: 'ClinicSegmentSendMessage',
        props: true,
        component: () => import('../views/admin/clinic/SegmentSendMessage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_message')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/:id/send-email',
        name: 'ClinicSegmentSendEmail',
        props: true,
        component: () => import('../views/admin/clinic/SegmentSendEmail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_email')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/:id/add-customers',
        name: 'ClinicSegmentDetailCustomers',
        props: true,
        component: () => import('../views/admin/clinic/SegmentAddCustomers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/clinic/manage',
        name: 'ClinicPageSetup',
        props: true,
        component: () => import('../views/admin/clinic/Manage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'manage')
          next()
        },
      },
      {
        path: '/admin/clinic/manage/provider',
        name: 'ClinicNewProvider',
        props: true,
        component: () => import('../views/admin/clinic/Provider.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_provider')
          next()
        },
      },
      {
        path: '/admin/clinic/manage/provider/:id',
        name: 'ClinicEditProvider',
        props: true,
        component: () => import('../views/admin/clinic/Provider.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_provider')
          next()
        },
      },
      {
        path: '/admin/clinic/manage/service',
        name: 'ClinicNewService',
        props: true,
        component: () => import('../views/admin/clinic/Service.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_service')
          next()
        },
      },
      {
        path: '/admin/clinic/manage/service/:id',
        name: 'ClinicEditSrvice',
        props: true,
        component: () => import('../views/admin/clinic/Service.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_service')
          next()
        },
      },
      {
        path: '/admin/clinic/user-settings',
        name: 'ClinicUserSettings',
        props: true,
        component: () => import('../views/admin/clinic/UserSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'user_settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings',
        name: 'ClinicSettings',
        props: true,
        component: () => import('../views/admin/clinic/Settings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/general',
        name: 'ClinicSettingsGeneral',
        props: true,
        component: () => import('../views/admin/clinic/settings/GeneralSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/payment',
        name: 'ClinicSettingsPayment',
        props: true,
        component: () => import('../views/admin/clinic/settings/PaymentSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/analytics',
        name: 'ClinicSettingsAnalytics',
        props: true,
        component: () => import('../views/admin/clinic/settings/Analytics.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/integration',
        name: 'ClinicSettingsIntegration',
        props: true,
        component: () => import('../views/admin/clinic/settings/IntegrationSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/billing/clinic-subscription',
        name: 'ClinicSettingsSubscription',
        props: true,
        component: () => import('../views/admin/clinic/settings/SubscriptionSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/billing/clinic-bills',
        name: 'ClinicSettingsBills',
        props: true,
        component: () => import('../views/admin/clinic/settings/BillsSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/account',
        name: 'ClinicSettingsAccount',
        props: true,
        component: () => import('../views/admin/clinic/settings/AccountSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/patient/import',
        name: 'PatientImport',
        component: () => import('../views/admin/clinic/PatientImportCustomers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'patient')
          next()
        },
      },
      {
        path: '/admin/clinic/patient/send-message',
        name: 'PatientSendMessage',
        component: () => import('../views/admin/clinic/PatientSendMessage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_message')
          next()
        },
      },
      {
        path: '/admin/clinic/patient/send-email',
        name: 'PatientSendEmail',
        component: () => import('../views/admin/clinic/PatientSendEmail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_email')
          next()
        },
      },
      {
        path: '/admin/review/review',
        name: 'Review',
        props: { os: 'review' },
        component: () => import('../components/review/listing/ReviewListingPage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'review')
          next()
        },
      },
      {
        path: '/admin/review/add-invite',
        name: 'Add Invite',
        props: { os: 'review' },
        component: () => import('../views/admin/review/AddInvites.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'review')
          next()
        },
      },
      {
        path: '/admin/review/general-settings',
        name: 'ReviewGeneralSettings',
        props: true,
        component: () => import('../views/admin/review/GeneralSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'General Settings')
          next()
        },
      },
      {
        path: '/admin/review/review-settings',
        name: 'ReviewSettings',
        props: { os: 'review' },
        component: () => import('../components/review/settings/ReviewSettingPage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Review Settings')
          next()
        },
      },
      {
        path: '/admin/review/settings/profile',
        name: 'ReviewSettingsProfile',
        props: true,
        component: () => import('../views/admin/review/settings/Profile.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Profile')
          next()
        },
      },
      {
        path: '/admin/billing/review-subscription',
        name: 'ReviewSettingsSubscription',
        props: true,
        component: () => import('../views/admin/review/settings/SubscriptionSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Subscription')
          next()
        },
      },
      {
        path: '/admin/billing/review-bills',
        name: 'ReviewSettingsBills',
        props: true,
        component: () => import('../views/admin/review/settings/BillsSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Bills')
          next()
        },
      },
      {
        path: '/admin/review/settings/account',
        name: 'ReviewSettingsAccount',
        props: true,
        component: () => import('../views/admin/review/settings/AccountSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Account')
          next()
        },
      },
      {
        path: '/admin/review/api-key',
        name: 'ReviewApiKey',
        props: true,
        component: () => import('../views/admin/review/settings/ApiKey.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'API Key')
          next()
        },
      },
      {
        path: '/admin/announcement',
        name: 'Announcement',
        props: true,
        component: () => import('../views/admin/Announcement.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'announcement')
          next()
        },
      },
      {
        path: '/admin/notifications',
        name: 'Notifications',
        props: true,
        component: () => import('../views/admin/Notifications.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'notifications')
          next()
        },
      },
      {
        path: '/admin/settings',
        name: 'Settings',
        props: true,
        component: () => import('../views/admin/Settings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/submit-ideas',
        name: 'SubmitIdeas',
        props: true,
        component: () => import('../views/admin/SubmitIdeas.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'submit_ideas')
          next()
        },
      },
      {
        path: '/admin/new-features',
        name: 'NewFeatures',
        props: true,
        component: () => import('../views/admin/NewFeatures.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_features')
          next()
        },
      },
      {
        path: '/admin/wallet',
        name: 'Wallet',
        props: true,
        component: () => import('../views/admin/Wallet.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'wallet')
          next()
        },
      },
      {
        path: '/admin/settings/general',
        name: 'SettingsGeneral',
        props: true,
        component: () => import('../views/admin/settings/main/GeneralSettings.vue'),
      },
      {
        path: '/admin/account',
        name: 'AccountSettings',
        props: true,
        component: () => import('../views/admin/settings/main/AccountSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/settings/notifications',
        name: 'SettingNotifications',
        props: true,
        component: () => import('../views/admin/settings/main/NotificationsSettings.vue'),
      },
      {
        path: '/admin/settings/books',
        name: 'SettingBooks',
        props: true,
        component: () => import('../views/admin/settings/main/BooksSettings.vue'),
      },
      {
        path: '/admin/billing/subscription',
        name: 'SubscriptionSettings',
        props: true,
        component: () => import('../views/admin/settings/main/SubscriptionSettings.vue'),
      },
      {
        path: '/admin/billing/bills',
        name: 'BillsSettings',
        props: true,
        component: () => import('../views/admin/settings/main/BillsSettings.vue'),
      },
      {
        path: '/admin/settings/order-settings',
        name: 'OrderManagementSettings',
        props: true,
        component: () => import('../views/admin/settings/OrderManagementSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'order_settings')
          next()
        },
      },
      {
        path: '/admin/settings/payment',
        name: 'SettingsPayment',
        props: true,
        component: () => import('../views/admin/settings/main/PaymentSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'payment')
          next()
        },
      },
      {
        path: '/admin/settings/checkout',
        name: 'SettingsCheckout',
        props: true,
        component: () => import('../views/admin/settings/main/CheckoutSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'checkout')
          next()
        },
      },
      {
        path: '/admin/settings/zoo',
        name: 'SettingsZoo',
        props: true,
        component: () => import('../views/admin/settings/main/ZooSettings.vue'),
      },
      {
        path: '/admin/settings/advance',
        name: 'SettingsAdvanceOld',
        props: true,
        component: () => import('../views/admin/settings/main/AdvanceSettingsOld.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'advanced_setup')
          next()
        },
      },
      {
        path: '/admin/settings/advance-new',
        name: 'SettingsAdvance',
        props: true,
        component: () => import('../views/admin/settings/main/AdvanceSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'advanced_setup')
          next()
        },
      },
      {
        path: '/admin/settings/advance-int',
        name: 'SettingsAdvanceInternational',
        props: true,
        component: () => import('../views/admin/settings/main/AdvanceSettingsInternational.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'advanced_setup')
          next()
        },
      },
      {
        path: '/admin/settings/shipping',
        name: 'YezzaShipping',
        props: true,
        component: () => import('../views/admin/settings/main/ShippingSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'shipping_and_delivery')
          next()
        },
      },
      {
        path: '/admin/settings/shipping-int',
        name: 'YezzaShippingInt',
        props: true,
        component: () => import('../views/admin/settings/YezzaShippingInternational.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'shipping_and_delivery')
          next()
        },
      },
      {
        path: '/admin/settings/shipping-new',
        name: 'YezzaShippingNew',
        props: true,
        component: () => import('../views/admin/settings/YezzaShipping.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'shipping')
          next()
        },
      },
      {
        path: '/admin/settings/easyparcel',
        name: 'EasyParcel',
        props: true,
        component: () => import('../views/admin/settings/EasyParcel.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'EasyParcel')
          next()
        },
      },
      {
        path: '/admin/settings/zeptoexpress',
        name: 'ZeptoExpress',
        props: true,
        component: () => import('../views/admin/settings/ZeptoExpress.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'ZeptoExpress')
          next()
        },
      },
      {
        path: '/admin/settings/lalamove',
        name: 'Lalamove',
        props: true,
        component: () => import('../views/admin/settings/Lalamove.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Lalamove')
          next()
        },
      },
      {
        path: '/admin/settings/woocommerce',
        name: 'WooCommerce',
        props: true,
        component: () => import('../views/admin/settings/WooCommerce.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'WooCommerce')
          next()
        },
      },
      {
        path: '/admin/settings/shopify',
        name: 'Shopify',
        props: true,
        component: () => import('../views/admin/settings/Shopify.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Shopify')
          next()
        },
      },
      {
        path: '/admin/settings/shopify/products',
        name: 'ShopifyProducts',
        props: true,
        component: () => import('../views/admin/settings/SyncShopifyProducts.vue'),
      },
      {
        path: '/admin/billing/payment-method',
        name: 'PaymentMethod',
        props: true,
        component: () => import('../views/admin/billing/PaymentMethod.vue'),
      },
      {
        path: '/admin/billing/bills/:id',
        name: 'BillDetails',
        props: true,
        component: () => import('../views/admin/billing/BillDetails.vue'),
      },
      {
        path: '/admin/billing/bills/:id/pay',
        name: 'PayBill',
        props: true,
        component: () => import('../views/admin/billing/PayBill.vue'),
      },
      {
        path: '/admin/billing/verify-payment',
        name: 'BillingVerifyPayment',
        props: true,
        component: () => import('../views/admin/billing/VerifyPayment.vue'),
      },
      {
        path: '/admin/afdebug',
        name: 'AffiliateDebug',
        component: () => import('../views/admin/AffiliateDebug.vue'),
      },
    ],
  },
  {
    path: '/print-invoices/:pid',
    name: 'PrintInvoiceHome',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
  },
  {
    path: '/print-invoices-small/:pid',
    name: 'PrintInvoiceSmallHome',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
  },
  {
    path: '/print-reports/:pid',
    name: 'YezzaBookReportsPrint',
    props: true,
    component: () => import('../views/admin/yezzabook/YezzaBookReports.vue'),
  },
  {
    path: '/print-packing-slips/:pid',
    name: 'YezzaPackingSlipsPrint',
    props: true,
    component: () => import('../views/admin/order/YezzaPackingSlips.vue'),
  },
  {
    path: '/print-pick-list/:pid',
    name: 'YezzaPickListPrint',
    props: true,
    component: () => import('../views/admin/order/YezzaPickList.vue'),
  },
  {
    path: '/receipts/:pid',
    name: 'Invoice<->Receipt',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
  },
  {
    path: '/quotations/:pid',
    name: 'Invoice<->Quotation',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
  },
  {
    path: '/track/:pid',
    name: 'ShippingTracking',
    component: () => import('../views/track/Home.vue'),
  },
 {
    path: '/invoices/crm/:pid',
    name: 'InvoiceHome',
    props: true,
    component: () => import('../views/invoice/crm/Home.vue'),
  },
  {
    path: '/invoices/:pid',
    name: 'InvoiceHome',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
    children: [
      {
        path: '/invoices/:pid/delivery',
        name: 'DeliveryOptionss',
        props: true,
        component: () => import('../views/invoice/UpdateDeliveryOptions.vue'),
      },
      {
        path: '/invoices/:pid/catalogs',
        name: 'UpdateProducts',
        props: true,
        component: () => import('../views/invoice/UpdateProducts.vue'),
      },
      {
        path: '/invoices/:pid/pay',
        name: 'PayInvoice',
        props: true,
        component: () => import('../views/invoice/PayInvoice.vue'),
      },
      {
        path: '/invoices/:pid/verify',
        name: 'VerifyPayment',
        props: true,
        component: () => import('../views/invoice/VerifyPayment.vue'),
      },
    ],
  },
  {
    path: '/:formSlug',
    name: 'FormHome',
    props: true,
    component: () => import('../views/forms/Home.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

window.$router = router

export default router
